export default {
    /* GET_TRADERS_MARK_UP
    ---------------------------------------------------------------
    */
    GET_TRADERS_MARK_UPS_REQUEST: (state) => {
        state.tradersMarkUpsLoading = true
    },
    GET_TRADERS_MARK_UPS_SUCCESS: (state, data) => {
        state.tradersMarkUps = data
        state.tradersMarkUpsLoading = false
    },
    GET_TRADERS_MARK_UPS_FAILURE: (state) => {
        state.tradersMarkUpsLoading = false
    },
    SET_TRADERS_MARK_UPS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_TRADERS_MARK_UPS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}